import React, {useState, useEffect} from 'react'
import "./index.scss"
import Table from 'react-bootstrap/Table'
import {useDispatch, useSelector} from 'react-redux'
import {
    fetchUserBills
} from '../../actions'
import moment from 'moment'

import BillModel from './billModel'
import ApplicationStatusModel from "../models/applicationStatusModel";
import FirmApplicationStatusModel from "../models/firmApplicationModel";
import pay_icon from '../../assets/images/icons/pay-icon.png'
import {useHistory} from 'react-router-dom'
import {FETCH_BILLERS_LOADING_ID} from '../../store/loaders'
import LoadingSpinner from '../../components/loadingSpiner'
import EmptyState from "../../components/EmptyState";
import empty_state_icon from '../../assets/images/empty-icon-1.png'







 const Billers = ()=>{

    const dispatch = useDispatch()
    const history = useHistory()


    const apiResponse = useSelector(state=>{
        const {userBillers,loader} = state
        const {data} = userBillers
        const {isLoading} = loader[FETCH_BILLERS_LOADING_ID] || {isLoading: false}
        return {
            data,
            isLoading
        }
    })


    const [showApplicationModel, setApplicationModel] = useState(false)
    const [showFirmModel, setFirmModel] = useState(false)
    const [modelData, setModelData] = useState('')
    const [firmData, setFirmData] = useState('')
    const [billerId, setBillerId] = useState('')
    const [showModel, setShowModel] = useState(false)


    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    const actionLoader = apiResponse.isLoading

     useEffect(()=>{
        dispatch(fetchUserBills(currentUser.sub))
     },[])


     const handleApplicationModel = (data)=>{
        if(data?.itemType === "FIRM APPLICATION"){
            setFirmData(data)
            setModelData('')
            setFirmModel(true)
            return 
        }
        if(data?.itemType === "INDIVIDUAL APPLICATION"){
            setApplicationModel(true)
            setFirmData('')
            setModelData(data)
            return
        }
        setFirmModel(false)
        setApplicationModel(false)
    }



    const handleView = (id)=>{
        setBillerId(id)
        setShowModel(true)
    }

     var paymentReport
     if(apiResponse.data?.length > 0){
        paymentReport = apiResponse.data.map((value, id)=>{
            if(value.billerId === undefined){
                value.billerId = value.id
            }
            value.id = value.referenceId
            
            return(
                <tr>
                <td>{moment(value.recordDate).format('MMMM Do YYYY, h:mm:ss a')}</td>
                {/* <td>{value.id}</td> */}
                <td>{value.itemType}</td>
                <td >{value.amount} {" "} {value?.currency}</td>
                <td className={value.status && value.status.toLowerCase()}>{value.status}</td>
                <td>
                   <div className="d-flex">
                        <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                            backgroundColor : 'white', border : '1px solid #00AE51'}} onClick={()=>handleView(value.billerId)}>
                            <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                <img style={{alignSelf : 'center'}}
                                src={require('../../assets/images/icons/icon_eye.svg').default}/>
                                <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>DETAILS</span>
                            </div>
                        </button>
                        <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                            backgroundColor : 'white', border : '1px solid #00AE51', marginLeft: 5}}
                            onClick={()=>handleApplicationModel(value)}
                            >
                            <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                                <img style={{alignSelf : 'center'}}
                                src={require('../../assets/images/icons/icon_eye.svg').default}/>
                                <span style={{fontSize : '10px', color : '#00AE51', marginTop : '3px'}}>Referenced Item</span>
                            </div>
                        </button>
                        {value.status?.toLowerCase() === 'unpaid' && <button style={{padding : '2px 10px', cursor : 'pointer', borderRadius : '3px',
                        backgroundColor : 'white', border : '1px solid #003D99', marginLeft:5}}
                        onClick={()=>history.push({
                            pathname: '/applicant/payment-details',
                            state: {
                                application: value,
                                isFirm:  value.itemType?.toLowerCase() === 'firm application' ? true : false,
                                isMembership: value.itemType?.toLowerCase() === 'membership' ? 3 : undefined,
                                headerSection: true

                            }
                        })}>
                        <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
                            <img style={{alignSelf : 'center'}}
                            src={pay_icon}/>
                            <span style={{fontSize : '10px', color : '#003D99', marginTop : '3px'}}>PAY</span>
                        </div>
                    </button> }
                    </div>
               </td>
            </tr>
            )
        })
     }

    return  (
        <div className="payments_wrapper">
            <div className="toolbar">
                <div className="toolbar-title">
                    <h2>Bills</h2>
                </div>
            </div>
            <br/><br/>
            {actionLoader ? 
                        
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'}}>
                            <LoadingSpinner
                                color={'#1D834F'}/>
                        </div>
                        : 
            <Table striped hover responsive>
                <thead>
                        <tr>
                            <th>Record Date</th>
                            <th>Item Type</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                </thead>
                    <tbody>
                        { paymentReport?.length > 0 ?
                        
                            paymentReport :
                            <tr>
                            <td colSpan={7} style={{padding: '100px 0px'}}>
                                <EmptyState
                                    header="No Bills available yet"
                                    content="Available bills will be displayed here"
                                    // noImage={true}
                                    img={empty_state_icon}
                                />
                            </td>
                        </tr>
                    }
                    </tbody>
            </Table>
                }
            <ApplicationStatusModel 
                show={showApplicationModel} 
                hide={handleApplicationModel}
                data={modelData}
            />
            <FirmApplicationStatusModel
                show={showFirmModel} 
                hide={handleApplicationModel}
                data={firmData}
            />
            <BillModel
                billerId={billerId}
                show={showModel}
                hide={()=>setShowModel(false)}/>
        </div>
    )
}

export default Billers